<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count= 'count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>客户:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model="query.name"></lk-input>
          </div>
          <div class="queryItem">
            <label>公司名称:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model="query.companyName"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="gotoHandleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>

      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
  </template>

<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';
import toolsService from '../../../services/lgq/services';

export default {
  name: 'customerList',
  mixins: [mapState, queryMixins],
  data() {
    return {
      size: 20,
      query: {
        name: '',
        companyName: '',
      },
      columns: [
        { title: '编号', key: 'customerCode', minWidth: 116 },
        { title: '姓名', key: 'name', minWidth: 60 },
        { title: '手机号', key: 'mobile', minWidth: 116 },
        { title: '公司名称', key: 'companyName', minWidth: 116 },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.createTime)),
        },
        {
          title: '修改时间',
          key: 'modifiedTime',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.modifiedTime)),
        },
        { title: '修改人', key: 'modifiedUserName', minWidth: 116 },
        { title: '状态', key: 'statusName', minWidth: 116 }, // 状态，1：待审核，2：启用，3：禁用
        {
          title: '账号启用禁用',
          key: 'status',
          minWidth: 116,
          render: (h, params) => h('lk-switch', {
            props: {
              size: 'large',
              value: params.row.status === 2,
              loading: params.row.loading,
            },
            on: {
              'on-change': (e) => {
                params.row.loading = true;
                this.updateStatus(params.row.id, e);
              },
            },
          }, [
            h('span', {
              props: {
              },
              slot: 'open',

            }, '启用'),
            h('span', {
              props: {
              },
              slot: 'close',

            }, '禁用'),
          ]),
        },
        {
          title: '操作',
          key: 'action',
          // fixed: 'right',
          width: 140,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          },
          [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'customerInfoEdit', params: { id: params.row.id } });
                },
              },
            }, '编辑'),
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'customerInfo', params: { id: params.row.id } });
                },
              },
            }, '查看'),
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    getData() {
      const params = utils.deepClone(this.query);
      params.page = this.page;
      params.size = this.size;
      toolsService.customerList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data.list;
          this.count = res.data.data.count || 0;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    gotoHandleSearch() {
      this.handleSearch();
    },
    clear() {
      this.query = {
        name: '',
        companyName: '',
      };
    },
    updateStatus(id, status) {
      toolsService.updateCustomerStatus({ id, status: status ? 2 : 3 })
        .then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('修改成功');
            this.getData();
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
  },
  mounted() {
    this.handleSearch(true);
  },
  components: {
    QueryFrame,
  },
};
</script>

<style scoped>
</style>
